import {Platform, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  listContainer: {
    marginLeft: 20, // Adjust as needed for indentation
    marginBottom: 10,
    width: Platform.OS === 'web' ? 'auto' : '90%',
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 5, // Adjust spacing between list items
  },
  bullet: {
    marginRight: 5, // Adjust spacing between bullet and item text
    fontSize: 16, // Adjust bullet size
  },
  itemText: {
    fontSize: 16, // Adjust item text size
  },
});
